import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import PanelShell from './PanelShell';

const StartPanel = ({ nodeType, nodeId, data, onChange }) => {
  if (nodeType !== 'Start' && !(nodeType === 'circularNode' && (data?.label === 'Start' || data?.label === 'Stop'))) return null;

  const setAsStart = () => onChange({ ...data, label: 'Start', Title: 'Start' });
  const setAsStop = () => onChange({ ...data, label: 'Stop', Title: 'Stop' });

  return (
    <PanelShell title="Başlat / Durdur" actions={null}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button
            fullWidth
            variant="contained"
            onClick={setAsStart}
          >
            Start Olarak Ayarla
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            fullWidth
            variant="contained"
            onClick={setAsStop}
          >
            Stop Olarak Ayarla
          </Button>
        </Grid>
      </Grid>
    </PanelShell>
  );
};

export default StartPanel;
